import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const FiltersSectionWrapper = styled.div``;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0 0.25rem;
  gap: 0.75rem;

  @media (min-width: ${breakpoints.md}) {
    gap: 1rem;
    padding: 1.25rem 0 0.75rem;
  }
`;

export const CategoriesWrapper = styled.div`
  display: flex;
  height: 36px;

  > div {
    overflow: unset;
    padding: 0 1rem;
  }

  a {
    border-radius: 2px;
  }
`;

export const FilterChipsWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0 1rem;
  &::after {
    content: '';
    padding-inline: 0.25em;
  }
`;

export const ChipCount = styled.span`
  color: ${theme.color.text.tertiary};
`;
